<template lang="pug">
#member-import-modal.modal-card
  header.modal-card-head
    p.modal-card-title Import Multiple Members
  section.modal-card-body
    p To import church members, choose a CSV file in the following format:
    table.table
      thead
        tr
          th Name
          th Phone Number
      tbody
        tr
          td
            small Johnny Appleseed
          td
            small (555) 555-5555
        tr
          td
            small Jane Appleseed
          td
            small (444) 444-4444
    b-field(grouped)
      b-upload(v-model="file")
        a.button
          b-icon(icon="file-delimited-outline")
          span Choose CSV
      b-switch(
        v-model="approve"
        type="is-success"
      ) Pre-approve all members
  footer.modal-card-foot
    a.button.is-success(
      :disabled="!file"
      :class="{ 'is-loading': settings.submitting }"
      @click="submit"
    ) Import
</template>

<script>
import { HTTP } from '@/utils/http';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'member-import-modal',
  data() {
    return {
      approve: true,
      file: null,
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    async submit() {
      if (this.file) {
        this.settings.submitting = true;
        const payload = new FormData();
        payload.append('file', this.file);
        payload.append('is_approved', this.approve);
        const { data } = await HTTP.post('/members', payload);
        setTimeout(() => {
          this.$parent.close();
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-success',
            message: data.message,
          });
          this.settings.submitting = false;
          this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss">
#member-import-modal {
  table.table {
    width: 100%;
    margin-top: 0.75rem;
    thead {
      tr {
        th {
          font-weight: normal;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MemberImportModal.vue